/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import App from 'apmui/App';
import bind from 'apmui/decorators/bind';
import * as React from 'react';
import {
    IOktaMfaModel,
    IOktaMfaEvent,
    NAV_FORM_ID,
    FIELD_TOTP,
    FIELD_PUSH,
    FIELD_OKTA,
    FIELD_YUBICO,
    Action,
} from './Model';
import ProgressAnimation from 'apmui/components/ProgressAnimation';
import Input from 'apmui/components/form/Input';
import { INPUT } from 'apmui/components/form/Model';
import EventTags from 'apmui/EventTags';
import Expandable from 'apmui/components/Expandable';
import OktaVerify from './OktaVerify';
import OktaSetup from './OktaSetup';
import YubicoSetup from './YubicoSetup';
import YubicoVerify from './YubicoVerify';

const app = App.get();

export default class OktaMfaView extends React.Component<IOktaMfaModel> {
    static defaultProps = {
        isEnrollSelected: false,
        enrollFactor: '',
        isPushSent: false,
    };

    state = {
        isEnrollSelected: OktaMfaView.defaultProps.isEnrollSelected,
        enrollFactor: OktaMfaView.defaultProps.enrollFactor,
        isPushSent: OktaMfaView.defaultProps.isPushSent,
    };

    render() {
        const { strings, state } = this.props.oktaMfa;
        let page;
        const className = 'apmui-content';
        const styleObj = { textAlign: 'left' as 'left' };
        const stylePushDisable = { cursor: 'not-allowed' as 'not-allowed' };
        const navigationForm = <form autoComplete="off" method="post" id={NAV_FORM_ID} hidden={true}></form>;
        if (!state.renderForm) {
            page = (
                <div className={className}>
                    <ProgressAnimation />
                </div>
            );
        } else {
            let styleDisable;
            if (this.state.isPushSent) {
                styleDisable = stylePushDisable;
            }
            if (!state.isEnrollment) {
                const options = [];
                if (state.isOtp || state.isPush) {
                    options.push({
                        value: FIELD_OKTA,
                        text: strings.oktaVerifyFactor,
                    });
                }
                if (state.isYubico) {
                    options.push({
                        value: FIELD_YUBICO,
                        text: strings.yubicoOtpFactor,
                    });
                }
                const showSelect = options.length > 1;
                const inputSelect = showSelect && (
                    <div>
                        <Input
                            type={INPUT.SELECT}
                            caption=""
                            name="factor_selector"
                            value={state.currentFactor}
                            options={options}
                            onChange={this.onFactorSelect}
                        />
                        <br />
                    </div>
                );
                const pushVerify = state.isPush && (
                    <span className="button-container">
                        <input
                            type="submit"
                            className="apmui-button apmui-button-submit apmui-button-long"
                            id="okta_push.verify"
                            value={strings.sendPush}
                            onClick={this.verifyPush}
                            disabled={this.state.isPushSent}
                            style={styleDisable}
                        />
                    </span>
                );
                const pushSent = this.state.isPushSent && <ProgressAnimation />;
                const oktaVerifyPage = (
                    <div>
                        {!showSelect && <h2>{strings.oktaVerifyFactor}</h2>}
                        {pushSent}
                        <br />
                        {pushVerify}
                        <br />
                        <br />
                        {state.isOtp && state.isPush && (
                            <Expandable caption={strings.orEnterCode} captionClassName="apmui-link">
                                <br />
                                <br />
                                <OktaVerify okta={this.props} onClick={this.handleEvent} transparent={true} />
                            </Expandable>
                        )}
                        {!state.isPush && <OktaVerify okta={this.props} onClick={this.handleEvent} />}
                    </div>
                );
                const yubicoVerifyPage = (
                    <div>
                        {!showSelect && <h2>{strings.yubicoOtpFactor}</h2>}
                        <YubicoVerify okta={this.props} />
                    </div>
                );
                const checkbox = state.factorsForEnrollment.length > 0 && (
                    <div>
                        <br />
                        <Input
                            type={INPUT.CHECKBOX}
                            caption={strings.setupMoreFactors}
                            name="setup_more_checkbox"
                            onChange={this.onCheckBoxSelect}
                        />
                        <br />
                    </div>
                );
                page = (
                    <div className={className} style={styleObj}>
                        {inputSelect}
                        {state.currentFactor == FIELD_OKTA && oktaVerifyPage}
                        {state.currentFactor == FIELD_YUBICO && yubicoVerifyPage}
                        {checkbox}
                    </div>
                );
            } else {
                if (state.resetEnrollmentPage) {
                    state.resetEnrollmentPage = false;
                    this.onShowEnrollFactors();
                }
                const authMessage = !this.state.isEnrollSelected && (
                    <div>
                        <h2>{strings.mfaSetupTitle}</h2>
                        <p>{strings.mfaSetupMsg}</p>
                    </div>
                );
                const enrollPageBtn = state.showEnrollPageBtn && (
                    <button className="apmui-button apmui-button-long" onClick={this.onShowEnrollFactors}>
                        {strings.back}
                    </button>
                );
                const finishBtn = !this.state.isEnrollSelected && (
                    <button className="apmui-button apmui-button-long" onClick={this.onFinish}>
                        {strings.finish}
                    </button>
                );
                page = (
                    <div className={className} style={styleObj}>
                        {authMessage}
                        <br />
                        {(state.isOtp || state.isPush) &&
                            (!this.state.isEnrollSelected ||
                                (this.state.isEnrollSelected &&
                                    (this.state.enrollFactor == FIELD_TOTP ||
                                        this.state.enrollFactor == FIELD_PUSH))) && (
                                <div>
                                    <OktaSetup
                                        okta={this.props}
                                        onClick={this.oktaVerifySetup}
                                        callback={this.handleEvent}
                                        enrollState={this.state}
                                    />
                                    <br />
                                </div>
                            )}
                        {state.isYubico &&
                            (!this.state.isEnrollSelected ||
                                (this.state.isEnrollSelected && this.state.enrollFactor == FIELD_YUBICO)) && (
                                <div>
                                    <YubicoSetup
                                        okta={this.props}
                                        onClick={this.yubicoSetup}
                                        enrollState={this.state}
                                    />
                                    <br />
                                </div>
                            )}
                        {enrollPageBtn}
                        {finishBtn}
                    </div>
                );
            }
        }
        return (
            <div className="apmui-content">
                {page}
                {navigationForm}
            </div>
        );
    }

    @bind
    handleEvent(data: IOktaMfaEvent) {
        app.dispatch(EventTags.OKTA_MFA_EVENT, data);
    }

    @bind
    verifyPush() {
        const data: IOktaMfaEvent = {
            action: Action.VERIFY,
            name: FIELD_PUSH,
        };
        app.dispatch(EventTags.OKTA_MFA_EVENT, data);
        this.setState({ isPushSent: true });
    }

    @bind
    showEnrollFactorsBtn() {
        const data: IOktaMfaEvent = {
            action: Action.UPDATE_STATE,
            name: 'showEnrollPageBtn',
            value: true,
        };
        app.dispatch(EventTags.OKTA_MFA_EVENT, data);
    }

    @bind
    oktaVerifySetup() {
        const { state } = this.props.oktaMfa;
        if (state.isPush) {
            const data: IOktaMfaEvent = {
                action: Action.ENROLL,
                name: FIELD_PUSH,
            };
            app.dispatch(EventTags.OKTA_MFA_EVENT, data);
            this.setState({ isEnrollSelected: true, enrollFactor: FIELD_PUSH });
        } else {
            const data: IOktaMfaEvent = {
                action: Action.ENROLL,
                name: FIELD_TOTP,
            };
            app.dispatch(EventTags.OKTA_MFA_EVENT, data);
            this.setState({ isEnrollSelected: true, enrollFactor: FIELD_TOTP });
        }
        this.showEnrollFactorsBtn();
    }

    @bind
    yubicoSetup() {
        this.setState({ isEnrollSelected: true, enrollFactor: FIELD_YUBICO });
        this.showEnrollFactorsBtn();
    }

    @bind
    onFactorSelect(name: string, value: string | boolean, event: Event) {
        const { form } = this.props.oktaMfa;
        form.fields = [];
        const data: IOktaMfaEvent = {
            action: Action.UPDATE_STATE,
            name: 'currentFactor',
            value: value,
        };
        app.dispatch(EventTags.OKTA_MFA_EVENT, data);
    }

    @bind
    onCheckBoxSelect(name: string, value: string | boolean, event: Event) {
        const data: IOktaMfaEvent = {
            action: Action.UPDATE_STATE,
            name: 'doEnrollAfterVerify',
            value: value,
        };
        app.dispatch(EventTags.OKTA_MFA_EVENT, data);
    }

    @bind
    onShowEnrollFactors() {
        const { form } = this.props.oktaMfa;
        form.fields = [];
        this.setState(OktaMfaView.defaultProps);
        const data: IOktaMfaEvent = {
            action: Action.INIT,
        };
        app.dispatch(EventTags.OKTA_MFA_EVENT, data);
    }

    @bind
    onFinish() {
        const data: IOktaMfaEvent = {
            action: Action.DONE,
        };
        app.dispatch(EventTags.OKTA_MFA_EVENT, data);
    }
}
